import WidgetClocks from "./widget-clocks-container";

export default WidgetClocks;